import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { RiLogoutCircleLine } from "react-icons/ri";
import { GiHamburgerMenu } from "react-icons/gi";
import EdsgLogo from "../../assets/images/SidebarLogo.png";
import useNavigationItems from "../../config/sideBarMenu";
import { usePatient } from "../../contexts";
import Cookies from "js-cookie";

const Sidebar = () => {
  const { setPatientId, setPatientInfo, setHmoDetails, setPatientName, setDiagnosis, nurseRoles } = usePatient();
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const sidebarRef = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const homeLink = Cookies.get("homeLink");

  const toggleSidebar = () => {
    setSidebarVisible((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setSidebarVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const resetPatientInfo = () => {
    setPatientInfo(null);
    setHmoDetails(null);
    setPatientName(null);
    setPatientId(null);
    setDiagnosis(null);
    Cookies.remove("patientInfo");
    Cookies.remove("patientName");
  };

  const handleMenuItemClick = (title, href) => {
    if (title === "Add a Patient") {
      localStorage.setItem("showAddPatientTabs", "true");
    } else {
      localStorage.removeItem("showAddPatientTabs");
    }
    resetPatientInfo();
    window.location.assign(href);
  };

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    Cookies.remove("patientInfo");
    window.location.assign('/');
  };

  const handleSupport = () => {
    window.location.href = "https://greenzonetechnologies.atlassian.net/servicedesk/customer/portals";
  };

  const navigationItems = useNavigationItems();

  return (
    <>
      {!isSidebarVisible && (
        <button className="hamburger-menu" onClick={toggleSidebar}>
          <GiHamburgerMenu size={24} />
        </button>
      )}
      <nav className={`page-sidebar ${isSidebarVisible ? "visible" : ""}`} ref={sidebarRef}>
        <div className="sidebar-header">
          <img src={'/ConnectHealthPro.png'} alt="logo" className="brand" width="150" />
        </div>
        <div className="sidebar-menu">
          <ul className="menu-items">
            {navigationItems.map((item) => (
              <MenuItem
                key={item.title}
                item={item}
                pathname={pathname}
                onMenuItemClick={handleMenuItemClick}
              />
            ))}
            <li className="pointer" onClick={logout}>
              <RiLogoutCircleLine className="icon" />
              <span className="title m-l-20">Log Out</span>
            </li>
            {/* <div style={{ position: "fixed", bottom: "0%", right: "30%", zIndex: 1000 }}>
              <img
                onClick={handleSupport}
                style={{ width: "120px", height: "120px", cursor: "pointer" }}
                alt="support"
                src="/Support.svg"
              />
            </div> */}
          </ul>
        </div>
      </nav>
    </>
  );
};

const MenuItem = ({ item: { title, href, icon, children }, pathname, onMenuItemClick }) => {
  const [showSubMenu, setShowSubMenu] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    if (children) {
      setShowSubMenu((prev) => !prev);
      return;
    }
    onMenuItemClick(title, href);
  };

  const handleSubItemClick = (sub) => {
    onMenuItemClick(sub.title, sub.href);
  };

  return (
    <>
      <li className={`${pathname === href ? "active" : ""} pointer`} onClick={(e) => handleClick(e)}>
        {icon}
        <span className="title m-l-20">{title}</span>
        {children && (
          <IoIosArrowBack
            className={`${showSubMenu ? "open" : ""} arrow`}
            onClick={(e) => {
              e.stopPropagation();
              setShowSubMenu((prev) => !prev);
            }}
          />
        )}
      </li>
      {children && showSubMenu && (
        <ul
          className="sub-menu show"
          style={{
            padding: "0px 0 5px 20px",
            margin: "0px 0 5px 20px",
            backgroundColor: "#f8f9fa",
            borderLeft: "3px solid #28a745",
            borderRadius: "4px",
            listStyleType: "none",
          }}
        >
          {children.map((sub) => (
            <li
              key={sub.title}
              className={`sub-menu-items ${pathname === sub.href ? "active" : ""} pointer`}
              onClick={() => handleSubItemClick(sub)}
              // onMouseOver={() => this.style.color='red'}
              style={{
                padding: "5px 10px",
                marginLeft: "15px",
                cursor: "pointer",
                borderRadius: "4px",
                transition: "background 0.3s, color 0.3s",
                color: pathname === sub.href ? "#ffffff" : "black",
                // backgroundColor: pathname === sub.href ? "#28a745" : "transparent",
              }}
            >
              ○ {sub.title}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default Sidebar;
